import { render, staticRenderFns } from "./locale-switcher.vue?vue&type=template&id=661847da"
import script from "./locale-switcher.vue?vue&type=script&lang=js"
export * from "./locale-switcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports